<template>
    <v-chart ref="line" :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    import 'echarts-gl'
    export default {
        name: "UserGetLineECharts",
        components: {
            'v-chart': ECharts,
        },
        props:{
            lineData:Object
        },
        watch:{
            lineData:function (newVal,oldVal) {
                this.$refs.line.clear();
                this.option.xAxis.data = newVal.settings.xAxis;
                this.option.series[0].data  = newVal.data.new_add_list;
                this.option.series[1].data  = newVal.data.new_register_list;
                this.option.series[2].data  = newVal.data.not_invite_add_list;
                this.option.series[3].data  = newVal.data.invite_add_list;
                this.loaded()
            }
        },
        data(){
            return {
                option: {
                    title:{
                      text:'趋势图',
                        left: '3%'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['日新增启动', '日新增注册', '非邀请新增', '邀请新增'],
                        bottom: '0'
                    },
                    grid: {
                        top:'8%',
                        left: '3%',
                        right: '3%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '日新增启动',
                            type: 'line',
                            // data: [120, 132, 101, 134, 90, 230, 210]
                            data: []
                        },
                        {
                            name: '日新增注册',
                            type: 'line',
                            // data: [220, 182, 191, 234, 290, 330, 310]
                            data: []
                        },
                        {
                            name: '非邀请新增',
                            type: 'line',
                            // data: [150, 232, 201, 154, 190, 330, 410]
                            data: []
                        },
                        {
                            name: '邀请新增',
                            type: 'line',
                            // data: [320, 332, 301, 334, 390, 330, 320]
                            data: []
                        }
                    ]
                }
            }
        },
        methods:{
            loading(){
                this.$refs.line.showLoading()
            },
            loaded(){
                this.$refs.line.hideLoading()
            }
        }
    }
</script>

<style scoped>
    .echarts{
        width: 100%;
        height: 100%;
    }
</style>